import { DialogContent, DialogTitle } from 'mrf/view/Dialog';
import Modal, { useModal } from 'mrf/view/Modal';
import T from "mrf/utils/T";
import { daoPut } from 'mrf/Dao';
import Button from 'mrf/view/Button';
import Flex from "mrf/layout/Flex";
import { Col } from "mrf/view/Grid";
import { KeyOffIcon } from 'styles/components/Icons';

export function RevokeTokenButton({ id }) {

    const dialog = useModal();

    const handleConfirm = async () => {
        try {
            await daoPut(`/api/CommunicationTokens/revoke/${id}`);
          
            dialog.close();
        } catch (error) {
            console.error("Failed to revoke token.");
            console.error(error);
        }
    };

    return (
        <>
            <Button icon={KeyOffIcon} tooltip="Revoke Token" onClick={() => dialog.open()} />

            <Modal modal={dialog.modal} close={() => dialog.close()}>
                <DialogTitle><T>Confirm Key Revocation</T></DialogTitle>
                <DialogContent gap={3}>
                    <p><T>Are you sure you want to revoke this Token?</T></p>
                    <p><strong><T>This action cannot be undone.</T></strong></p>

                    <Flex justify="center">
                        <Col size={4}>
                            <Button 
                            color="secondary" onClick={() => dialog.close()} className="mt-4">
                                <T>Cancel</T>
                            </Button>
                        </Col>

                        <Col size={4}>
                            <Button color="primary" onClick={handleConfirm} className="mt-4">
                                <T>Confirm</T>
                            </Button>
                        </Col>
                    </Flex>
                </DialogContent>
            </Modal>
        </>
    );
}